<template>
  <div>
    <yd-table
      :loading="loading"
      element-loading-text="正在加载中～"
      :pagination="pages"
      @onChange="onTableChange"
      :columns="columns"
      :settings="false"
      size="mini"
      :data="list"
    >
      <template #orderNo="{ row }">
        <span style="cursor: pointer" class="color-mainColor" @click="showDetail(row)">{{
          row.orderNo
        }}</span>
      </template>
      <template #type="{ row }">
        <el-tag :type="row.type === 1 ? 'primary' : 'success'">{{
          row.type === 1 ? '送机/站' : '接机/站'
        }}</el-tag>
      </template>
    </yd-table>
    <order-info ref="orderInfoRef" />
  </div>
</template>
<script >
import { watch, ref, reactive } from '@vue/composition-api';
import { getPickupList } from '@/api/user';
import OrderInfo from '@/views/order/ferry/order-info.vue';
const __sfc_main = {};
__sfc_main.props = {
  userId: {
    type: String,
    default: ''
  },
  firstList: {
    type: Object,
    default: () => {}
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const loading = ref(false);
  const list = ref([]);
  const pages = reactive({
    current: 1,
    pageSize: 5,
    total: 100
  });
  const columns = ref([{
    label: '订单号',
    prop: 'orderNo',
    width: 200
  }, {
    label: '出发时间',
    prop: 'departureDateTime'
  }, {
    label: '出发地',
    prop: 'startAddress'
  }, {
    label: '目的地',
    prop: 'endAddress'
  }, {
    label: '订单状态',
    prop: 'stateStr'
  }, {
    label: '订单金额(元)',
    prop: 'payAmount'
  }, {
    label: '行程类型',
    prop: 'type'
  }]);
  const orderInfoRef = ref(null);
  const showDetail = row => {
    row.ferryOrderNo = row.orderNo;
    orderInfoRef.value.init(row);
  };
  const genList = res => {
    const {
      current,
      size,
      total,
      records
    } = res;
    pages.current = current;
    pages.pageSize = size;
    pages.total = total;
    list.value = records;
  };
  const getList = async () => {
    loading.value = true;
    const {
      code,
      data
    } = await getPickupList({
      current: pages.current,
      size: pages.pageSize,
      userId: props.userId
    });
    loading.value = false;
    if (code !== 0) {
      return;
    }
    genList(data);
  };
  const onTableChange = ({
    current,
    pageSize
  }) => {
    pages.current = current;
    pages.pageSize = pageSize;
    getList();
  };
  watch(() => props.firstList, v => {
    genList(v);
  }, {
    immediate: true
  });
  return {
    loading,
    list,
    pages,
    columns,
    orderInfoRef,
    showDetail,
    onTableChange
  };
};
__sfc_main.components = Object.assign({
  OrderInfo
}, __sfc_main.components);
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
